import React from "react";

import { db, firebase } from "astrid-firebase";
import createImprintData from "astrid-firestore/src/api/imprints/createImprintData";

import Form from "../../../forms/components/Form/Form";

export default function ArticleMetaDataImprintSelect({ name, publisher }) {
	return (
		<Form.CollectionSelect
			name={name}
			query={
				publisher &&
				db.collection("imprints").where("publisher.id", "==", publisher.id).where("deleted", "==", false)
			}
			onAddDocument={(name) => createImprintData(firebase, { name, publisher })}
			allowAdditions
			allowEmpty
			search
		/>
	);
}
